export enum LoginErrorCode {
    AccountDisabled = "AccountDisabled",
    InvalidCredentials = "InvalidCredentials"
}
